import { isWorldPanel } from '@helpers';

import styles from './_index.module.scss';

const Footer = () => {
  const footerText = isWorldPanel()
    ? 'Powered by Worldpanel by Numerator'
    : 'Powered by Numerator OmniPanel';

  return <div className={styles['footer']}>{footerText}</div>;
};

export default Footer;
